<template>
  <v-dialog v-model="dialog" persistent max-width="750px">
    <v-card>
    <div class="survey-container">
      
      <div class="survey-type-container" style="position: relative;" v-show="selectedType === ''">
        <div style="position: absolute; top: 20px; right: 0; cursor: pointer;">
          <img
            class="excel-closeBtn"
            src="../../../src/images/button/btnClose.png"
            @click="close()"
          />
        </div>
        <div style="font-size: 20px; font-weight: bold; margin: 30px 0 ;">유형을 선택해주세요.</div>
        <div class="type-container">
          <div class="type-btn" @click="selectType('quiz')">퀴즈</div>
          <div class="type-btn" @click="selectType('survey')">설문조사</div>
          <div class="type-btn" @click="selectType('exam')">문제출제</div>
        </div>
      </div>
      <div class="create-suvey-container" v-show="selectedType !== ''">
        
          <div class="dialog-container" style="width: 100%">
            <div class="dialog-header">
              <h1 class="header-title">{{ selectedType }} 만들기</h1>
            </div>
          <v-card-text>
            <input type="text" placeholder="제목을 입력해주세요" ref="surveyTitle" v-model="survey.title" class="form-input">
            <!-- <v-text-field class="survey-title" label="설문 제목" outline dense ref="surveyTitle" v-model="survey.title"/> -->
            <v-stepper v-model="e1" class="survey-body">
              <v-container grid-list-md>
                <v-layout nowrap>
                  <v-flex xs1>
                    <vue-perfect-scrollbar style="height: 450px;">
                      <template v-for="n in steps">
                        <v-stepper-step
                          class="survey-step"
                          :key="`${n}-step`"
                          :complete="e1 > n"
                          :step="n"
                          editable
                        >
                        </v-stepper-step>

                        <v-divider
                          v-if="n !== steps"
                          :key="n"
                        ></v-divider>
                      </template>
                    </vue-perfect-scrollbar>
                  </v-flex>
                  <v-flex xs10>
                    <v-stepper-items>
                      <v-stepper-content
                        v-for="n in steps"
                        :key="`${n}-content`"
                        :step="n"
                      >
                        <vue-perfect-scrollbar>
                          <v-card
                            v-if="survey"
                          >
                            <v-container>
                              <v-layout>
                                <v-flex xs8>
                                  <input type="text" placeholder="질문" ref="surveyTitle" v-model="survey.questions[n - 1].question" class="form-input" style="width: 95%; height: 45px;">
                                  <!-- <v-text-field class="question-title" label="질문" v-model="survey.questions[n - 1].question"></v-text-field> -->
                                </v-flex>
                                <v-flex xs4>
                                  <v-select
                                    label="질문 유형"
                                    class="question-type"
                                    v-model="survey.questions[n - 1].type"
                                    :items="surveyItems"
                                  />
                                </v-flex>
                              </v-layout>
                              <v-layout>
                                <v-flex xs12>
                                  <!-- <div v-if="survey.questions[n - 1].type === 'text'">
                                    <v-textarea
                                      label="답변 UI"
                                      readonly
                                      disabled
                                    />
                                  </div> -->
                                  <div v-if="survey.questions[n - 1].type !== 'text'">
                                    <v-radio-group 
                                      v-if="survey.questions[n - 1].type === 'radio'"
                                      v-model="deleteProperties"
                                    >
                                      <v-radio
                                        v-for="(item, index) in survey.questions[n - 1].items"
                                        :key="index"
                                        :label="item"
                                        :value="item"
                                      ></v-radio>
                                    </v-radio-group>
                                    <v-flex style="margin-top: 30px;" v-else>
                                      <v-checkbox
                                        v-for="(item, index) in survey.questions[n - 1].items"
                                        v-model="deleteProperties"
                                        :key="index"
                                        :label="item"
                                        :value="item"
                                        style="margin-top: -25px !important; padding-top: 0px !important;"
                                      />
                                    </v-flex>
                                    <div>
                                      <input type="text" placeholder="새로운 항목" ref="surveyTitle" v-model="newProperty" class="form-input" style="width: 90%; margin-bottom: 10px;">
                                      <div style="display: flex; flex-direction: row;">
                                        <button class="noIconButton" @click="addProperty" style="margin-left: 0px; display: flex; margin-right: 5px;">
                                          <img src="/static/icon-contents/plus-7.svg" alt="">항목 추가
                                        </button>
                                        <button v-if="survey.questions[n - 1].items.length > 0" class="noIconButton" @click="deleteProperty" style="margin-left: 0px; display: flex;">
                                          <img src="/static/icon-contents/delete-2.svg" style="width: 20px; margin: 0 4px;">항목 삭제
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </v-flex>
                              </v-layout>
                            </v-container>
                          </v-card>
                        </vue-perfect-scrollbar>
                      </v-stepper-content>
                    </v-stepper-items>
                  </v-flex>
                </v-layout>
                <button class="btnPrimary noIconButton" @click="addSurveyQuestion">
                  문항추가
                </button>
                <button class="noIconButton" @click="deleteSurveyQuestion">문항삭제</button>
              </v-container>
            </v-stepper>
          </v-card-text>
          <v-card-actions style="padding: 10px;">
            <v-spacer></v-spacer>
            <button class="btnPrimary noIconButton" @click="save">
              생성
            </button>
            <button class="noIconButton" @click="cancel">취소</button>
          </v-card-actions>
          </div>
        
      </div>
    </div>
    </v-card>
  </v-dialog>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import Util from '@/util';

export default {
  components: {
    VuePerfectScrollbar
  },
  props: {
    dialog: { type: Boolean, default: false },
    isEdit: { type: Boolean, default: false },
    editSurvey: { type: Object },
    editSteps: { type: Number },
    meetingKey: { type: String },
    close: { type: Function },
  },
  data () {
    return {
      e1: 1,
      operty: null,
      steps: 1,
      currentStep: 1,
      survey: {
        title: '',
        creator: this.$store.state.user,
        questions: [
          {
            number: 1,
            question: '',
            type: 'radio',
            items: [],
            answer: null
          }
        ],
      },
      defaultQuestion: {
        number: 1,
        question: '',
        type: 'text',
        items: [],
        answer: null
      },
      newProperty: null,
      surveyItems: [
        { text: '서술형', value: 'text' },
        { text: '단일 선택', value: 'radio' },
        { text: '다중 선택', value: 'check' },
      ],
      deleteProperties: null,
      selectedType: '',
    };
  },
 
  watch: {
    dialog: {
      handler (val) {
        if (val && this.isEdit) {
          this.selectedType = this.survey.selectedType;
          this.survey = Object.assign({}, this.editSurvey);
          this.steps = this.editSteps;
        } else {
          this.selectedType = '';
          this.survey = {
            title: '',
            creator: this.$store.state.user,
            questions: [
              {
                number: 1,
                question: '',
                type: 'radio',
                items: [],
                answer: null
              }
            ],
          };
          this.steps = 1;
        }
      }
    },
    currentStep (newVal) {
      console.log(`currentStep : `, newVal); 
    }
  },
  methods: {
    addSurveyQuestion () {
      const question = this.survey.questions[this.steps - 1].question;
      const type = this.survey.questions[this.steps - 1].type;
      if (question === null || question.trim() === '') {
        alert('질문을 입력해주세요.');
        return;
      }
      if (type !== 'text') {
        const items = this.survey.questions[this.steps - 1].items;
        if (items.length < 1) {
          alert('1개 이상의 항목이 필요합니다.');
          return;
        }
      }

      this.survey.questions = this.survey.questions.concat({
        ...this.defaultQuestion,
        number: this.steps
      });
      this.steps = this.steps + 1;
      this.e1 = this.steps;
    },
    deleteSurveyQuestion () {
      if (this.survey.questions.length < 2) {
        alert('1개 이상의 문항이 필요합니다.');
        return;
      }
      

      this.survey.questions.splice(this.e1 - 1, 1);
      this.steps = this.steps - 1;
      this.e1 = this.steps;
    },
    addProperty () {
      console.log(this.newProperty);
      if (this.newProperty === '' || this.newProperty === null || this.newProperty === undefined) {
        alert('항목을 입력해주세요.');
        return;
      }
      if (this.survey.questions[this.steps - 1].items.findIndex(item => item === this.newProperty) > -1) {
        alert('동일한 항목이 있습니다.');
        return;
      }
      console.log(this.survey.questions[this.steps - 1].items);
      this.survey.questions[this.steps - 1].items = this.survey.questions[this.steps - 1].items.concat(this.newProperty);
      this.newProperty = null;
    },
    deleteProperty () {
      const index = this.survey.questions[this.steps - 1].items.findIndex(item => item === this.deleteProperties);
      if (index > -1) {
        this.survey.questions[this.steps - 1].items.splice(index, 1);
      }
    },
    async save () {
      console.log(this.survey);
      if (this.survey.title === null || this.survey.title.trim() === '') {
        alert('설문 제목을 입력하세요');
        return;
      }
      const noQuestions = this.survey.questions.filter(question => question.question === null || question.question.trim() === '');
      if (noQuestions.length > 0) {
        alert('질문을 입력하지 않은 문항이 있습니다');
        return;
      }
      
      let surveyInfo = {
        meetingKey: this.meetingKey,
        survey: this.survey,
        creator: this.$store.state.user.email,
        selectedType: this.selectedType,
      };
      if (this.isEdit) {
        // 수정
        await this.$http
          .post('/api/v1/surveys/editSurvey', surveyInfo)
          .then((response) => {
            
            if (response.data) {
              alert('문항이 수정되었습니다.');
              this.close();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        await this.$http
          .post('/api/v1/surveys', surveyInfo)
          .then((response) => {
            if (response.data) {
              alert('문항 등록이 완료되었습니다.');
              this.close();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    cancel () {
      this.close();
    },
    
    selectType (type) {
      if (type === 'quiz') {
        this.selectedType = '퀴즈';
      } else if (type === 'survey') {
        this.selectedType = '설문조사';
      } else if (type === 'exam') {
        this.selectedType = '문제출제';
      }
    }
  }
};
</script>

<style scoped>
.v-stepper {
  box-shadow: none;
}
.survey-type-container {
  min-height: 330px;
  display: flex;
  justify-content: start;
  align-items: center;
  flex-direction: column;
}
.type-container { 
  display: flex;
  justify-content: center;
  align-items: center;
}
.survey-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.type-btn {
  width: 200px;
  height: 200px;
  background-color: #23408E;
  margin: 0 10px;
  border-radius: 4px;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  cursor: pointer;
  border-radius: 10px;
}

.type-btn:hover{
  background-color: #0066FF;
}

.header-title {
  color: white;
  font-size: 18px;
  padding-left: 20px;
}

.dialog-header { 
  height: 50px;
  background-color: #23408e;
}

.form-input {
  width: 100%;
  height: 35px;
  padding: 0 5px;
  border: 1px solid #ddd;
  border-radius: 4px;
}
input::placeholder {color:#aaa}

button,.btn {
  position: relative;
  display: inline-block;
  height: 30px;
  line-height: 28px;
  padding: 0 12px 0 34px;
  border: 1px solid #ddd;
  background: #fff;
  border-radius: 4px;
  font-size: 13px;
  text-align: center;
  margin-left:5px;
  cursor: pointer;
  color:#555;
}
.create-suvey-container {
  width: 100%;
}
button.btnPrimary,.btnPrimary {color:#fff; background: #23408e;border-color:#23408e}
button.btnPrimary:hover,.btnPrimary:hover {color:#fff; background: #477ADB;border-color:#477ADB}
.btnsArea button:first-child {margin-left:0}
button.noIconButton {padding: 0 12px;}
button.onlyIconButton {padding: 0 8px;}
button.onlyIconButton img {vertical-align: middle;}
button.onlyIconButton.ico_search img {width:18px; position: relative; top:-2px;}
button.onlyIconButton.ico_search:hover img {filter: invert(36%) sepia(0%) saturate(10%) hue-rotate(71deg) brightness(92%) contrast(89%);}
button:hover,button.btn:hover {color: #23408e; border-color: #23408e;}
button:hover i,button.btn:hover i {color: #23408e;}
button.btnPrimary:hover i {color: #fff;}
button.btnDisable,button.btnDisable:hover {background:#f1f1f1;border-color:#ddd; color:#999; cursor:not-allowed}
button.noIconButton.small {height:23px;padding: 0 10px;font-size:12px;line-height: 20px;} 
</style>


// WEBPACK FOOTER //
// src/components/popup/KsdSurvey.vue